import script from "./CBridge.vue?vue&type=script&lang=ts&setup=true"
export * from "./CBridge.vue?vue&type=script&lang=ts&setup=true"

import "./CBridge.vue?vue&type=style&index=0&id=79e5b85e&scoped=true&lang=scss"

import exportComponent from "../../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79e5b85e"]])

export default __exports__